// eslint-disable-next-line import/prefer-default-export
export const ENABLED_FEATURES = {
  UNSAFE_USER_SALARY: "unsafeUserSalary",
  frontendShowAllModules: "frontendShowAllModules",
  FRONTEND_SHOW_ALL_MODULES: "frontendShowAllModules",
};
